<div class="admin-menu-small">
  <ng-container *ngFor="let menuItem of menuItems">
    <div
      *ngIf="!menuItem.disabled"
      [routerLink]="menuItem.route"
      routerLinkActive="admin-menu-small__item--active"
      [ngClass]="{
        'admin-menu-small__item--current': menuItem.currentStep
      }"
      class="admin-menu-small__item"
    >
      <span class="admin-menu-small__title" translate
        >{{ menuItem.title }}</span
      >
      <svg-icon class="admin-menu-small__icon" [src]="menuItem.icon"></svg-icon>
    </div>
    <div
      *ngIf="menuItem.disabled"
      class="admin-menu-small__item admin-menu-small__item--disabled"
    >
      <span class="admin-menu-small__title" translate
        >{{ menuItem.title }}</span
      >
      <svg-icon class="admin-menu-small__icon" [src]="menuItem.icon"></svg-icon>
    </div>
  </ng-container>
</div>
